import cookie from 'js-cookie'
import { getExpDate, setTokenHeader } from './actions/authenticationActions'

const loadState = () => {
  try {
    const userData = cookie.getJSON('userData');
    let state = {}

    if (userData) {
      const expDate = getExpDate(userData.jwtToken);
      if (expDate > new Date()) {
        setTokenHeader(userData.jwtToken);
        state = {
          auth: {
            id: userData.id,
            email: userData.email,
            firstName: userData.firstName,
            lastName: userData.lastName,
            userName: userData.userName,
            jwtToken: userData.jwtToken,
            roles: userData.roles
          }
        }
      }
    }

    return state
  } catch (err) {
    return undefined
  }
}

export default loadState
